import { create } from "zustand";

const useVipMultiviewSoundStore = create((set) => ({
  // Default state - muted with 50% volume
  isMuted: true,
  volume: 50,

  // Actions
  setMuted: (muted) => set({ isMuted: muted }),
  setVolume: (volume) => set({ volume: Math.min(100, Math.max(0, volume)) }),
  toggleMute: () => set((state) => ({ isMuted: !state.isMuted })),
  increaseVolume: () =>
    set((state) => ({
      volume: Math.min(100, state.volume + 10),
    })),
  decreaseVolume: () =>
    set((state) => ({
      volume: Math.max(0, state.volume - 10),
    })),
}));

export default useVipMultiviewSoundStore;
